export default {
  labels: {
    sold_out: 'Wyprzedane!',
    most_popular: '#{{rank}} Najpopularniejsze',
    last_ordered: 'Ostatnio zamówione',
  },
};
